import React, { useEffect } from 'react'
import classes from "./SubscriptionInProcess.module.css";
const SubscriptionInProcess = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      
      window.location.href = '';
    }, 2000);

    return () => clearTimeout(timer);
  }, []);
  return (
      <div className={classes.wrapper}>
  <div className={classes.container}>
    <h1 className={classes.title}>Subscription In Process</h1>

    <p className={classes.message}>
    Your subscription is in process!
    </p>   

    <div className={classes.pleaseWait}>Please Wait</div>

    <div className={classes.finalNote}>
      You will be auto redirected when successfully subscribed!
    </div>
  </div>
</div>
  )
}

export default SubscriptionInProcess
